import type { SVGProps } from 'react';

export const ArrowDropDown = (props: SVGProps<any>) => (
  <svg
    height="6px"
    role="img"
    viewBox="0 0 10 6"
    width="10px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'arrow drop down'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth={1}>
      <g fill={props.fill} transform="translate(-138.000000, -103.000000)">
        <g transform="translate(48.000000, 96.000000)">
          <polygon
            points="95 7 100 13 90 13"
            transform="translate(95.000000, 10.000000) scale(1, -1) translate(-95.000000, -10.000000) "
          />
        </g>
      </g>
    </g>
  </svg>
);
